import { useInfiniteQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export const useYourBidInfinite = (type: string) => {
  const axios = useAxios();
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const panel = Number(queryParams.get("panel"));

  const recentInfinite: any = useInfiniteQuery({
    queryKey: [`Your-Bid-infinite-list`],
    queryFn: async ({ pageParam = 1 }) => {
      const urlKey = `${t("bid-property-list-api")}?page=${pageParam}&limit=10`;
      const res = await axios.get(urlKey);
      return res?.data?.data;
    },
    refetchOnMount: false,
    initialPageParam: 1,
    getNextPageParam: (lastPage: any, allPages: any) => {
      if (lastPage?.length < 10) return undefined;
      return allPages.length + 1;
    },
    refetchOnWindowFocus: false,
    enabled: panel === 1 && window.innerWidth <= 768 && type === "agent"
  });
  return recentInfinite;
};
